import { Component, effect, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { UiStateService } from '../../../core/services/ui-state.service';

@Component({
  selector: 'app-sidenav',
  standalone: true,
  imports: [],
  templateUrl: './sidenav.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sidenav.component.css',
})
export class SidenavComponent {
  private uiState = inject(UiStateService);
  isOpen = signal(false);

  constructor() {
    // Sync local state with global UI state
    effect(() => {
      this.isOpen.set(this.uiState.sidenavOpen());
    });
  }

  toggle(): void {
    this.uiState.toggleSidenav();
  }

  close(): void {
    this.uiState.closeSidenav();
  }

  open(): void {
    this.uiState.openSidenav();
  }
}
